(function() {
  'use strict';

  let lastKnownCount = null;

  async function updateAllCartCounters() {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) return;
      
      const cart = await response.json();
      const itemCount = cart.item_count || 0;

      if (lastKnownCount !== itemCount) {
        const cartCountElements = document.querySelectorAll('.cart_count');
        cartCountElements.forEach(element => {
          element.textContent = itemCount;
        });
        lastKnownCount = itemCount;
      }
    } catch (error) {
      console.warn('[Cart Counter] Update failed:', error);
    }
  }

  document.addEventListener('cart:update-counter', function() {
    updateAllCartCounters();
  });

  document.addEventListener('rebuy:cart.change', function() {
    updateAllCartCounters();
  });

  document.addEventListener('rebuy:cart-update', function() {
    updateAllCartCounters();
  });

  const drawerSelectors = [
    'rebuy-cart',
    '[data-rebuy-cart]',
    '.rebuy-cart',
    'cart-drawer',
    '[data-cart-drawer]',
    '.cart-drawer'
  ];

  function observeDrawer() {
    drawerSelectors.forEach(selector => {
      const drawer = document.querySelector(selector);
      if (drawer) {
        const observer = new MutationObserver(function() {
          updateAllCartCounters();
        });
        observer.observe(drawer, { 
          childList: true, 
          subtree: true,
          attributes: true,
          attributeFilter: ['data-cart-count', 'data-item-count']
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeDrawer);
  } else {
    observeDrawer();
  }

  setTimeout(observeDrawer, 1000);

})();
